export enum SelectedTypeOptions {
    SellingPriceManipulation,
    PurchasePriceManipulation,
}
